import IconButton from "@mui/material/Button";
import DialogTitle from '@mui/material/DialogTitle';
import Dialog from '@mui/material/Dialog';
import OutlinedInput from '@mui/material/OutlinedInput';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import {DialogContent, TextField} from "@mui/material";
import * as React from "react";
import SettingsIcon from '@mui/icons-material/Settings';
import {useState} from "react";
import DeleteIcon from "@mui/icons-material/Delete";

export const DataSelecter = (props) => {
    const [open, setOpen] = useState(false)
    const [chartTypes, setChartTypes] = useState(['line','bar','column'])

    const handleCloseAndSave = () => {
        setOpen(false)
        props.handleCloseAndSave()
    }
    return (
        <div>
            <IconButton size={'small'} sx={{minWidth:0, right:'35px',position:'absolute',zIndex:999}} onClick={()=>setOpen(true)}>
                <SettingsIcon/>
            </IconButton>
            <Dialog onClose={handleCloseAndSave} open={open}>
                <DialogTitle>제목, 관리대상 및 관리항목 설정</DialogTitle>
                <DialogContent>
                    <div>
                        <TextField sx={{input:{color:'white'}, margin:'15px', '.MuiOutlinedInput-notchedOutline': {borderColor: 'rgba(243,232,248,0.82)',},
                            '&.Mui-focused .MuiOutlinedInput-notchedOutline': {borderColor: 'rgba(243,232,248,0.82)',},
                            '&:hover .MuiOutlinedInput-notchedOutline': {borderColor: 'rgba(243,232,248,0.82)',},
                            '.MuiSvgIcon-root ': {fill: "white !important",}}} placeholder={"set chart title"} onChange={props.handleTitleChange} />
                    </div>
                    <div>
                        <FormControl sx={{margin:'15px'}}>
                            <Select
                                sx={{color: "white", '.MuiOutlinedInput-notchedOutline': {borderColor: 'rgba(243,232,248,0.82)',},
                                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {borderColor: 'rgba(243,232,248,0.82)',},
                                    '&:hover .MuiOutlinedInput-notchedOutline': {borderColor: 'rgba(243,232,248,0.82)',},
                                    '.MuiSvgIcon-root ': {fill: "white !important",}
                                }}
                                fullWidth
                                value={props.sensor}
                                onChange={props.handleSensorChange}
                                input={<OutlinedInput />}

                            >
                                {props.sensorList.map((x) => (
                                    <MenuItem className="dashboard_admin_select" key={x.moNo} value={x.moNo}>{x.moDispName}</MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                        <FormControl sx={{margin:'15px'}}>
                            <Select
                                sx={{color: "white", '.MuiOutlinedInput-notchedOutline': {borderColor: 'rgba(243,232,248,0.82)',},
                                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {borderColor: 'rgba(243,232,248,0.82)',},
                                    '&:hover .MuiOutlinedInput-notchedOutline': {borderColor: 'rgba(243,232,248,0.82)',},
                                    '.MuiSvgIcon-root ': {fill: "white !important",}
                                }}
                                fullWidth
                                value={props.psItem}
                                onChange={props.handlePsItemChange}
                                input={<OutlinedInput />}

                            >
                                {props.psItemList.map((x) => (
                                    <MenuItem className="dashboard_admin_select" key={x.psId} value={x.psId}>{x.psName}</MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </div>
                    {props.base =="base" ?
                        <div>
                            <FormControl sx={{margin:'15px'}}>
                                <Select
                                    sx={{color: "white", '.MuiOutlinedInput-notchedOutline': {borderColor: 'rgba(243,232,248,0.82)',},
                                        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {borderColor: 'rgba(243,232,248,0.82)',},
                                        '&:hover .MuiOutlinedInput-notchedOutline': {borderColor: 'rgba(243,232,248,0.82)',},
                                        '.MuiSvgIcon-root ': {fill: "white !important",}
                                    }}
                                    fullWidth
                                    value={props.chartType}
                                    onChange={props.handleChartTypeChange}
                                    input={<OutlinedInput />}

                                >
                                    {chartTypes.map((x) => (
                                        <MenuItem className="dashboard_admin_select" key={x} value={x}>{x}</MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </div> : ''}
                </DialogContent>
            </Dialog>
        </div>

    )
}